import { useEffect } from "react";
import { useSearchParams } from "react-router";

import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectOverviewDateFilterState } from "../../../store/selectors/overview";
import { setOverviewDateFilter } from "../../../store/overview/slice";
import type { DateFilter } from "../../../components/DatePeriodSelector/types";
import {
  parseDateFilterFromSearchParams,
  dateFilterToSearchParams,
} from "../utils/overviewDateFilterSearchParams";

export interface UseOverviewDateFilterFromUrlResult {
  dateFilter: ReturnType<typeof selectOverviewDateFilterState>;
  setDateFilterFromUrl: (filter: DateFilter) => void;
}

/**
 * Syncs URL search params with overview date filter in Redux.
 * Reads filter from URL on mount/change and provides handler to update URL when filter changes.
 */
export function useOverviewDateFilterFromUrl(): UseOverviewDateFilterFromUrlResult {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const dateFilter = useAppSelector(selectOverviewDateFilterState);

  useEffect(() => {
    const filterFromUrl = parseDateFilterFromSearchParams(searchParams);
    if (filterFromUrl != null) {
      dispatch(setOverviewDateFilter(filterFromUrl));
    }
  }, [searchParams, dispatch]);

  const setDateFilterFromUrl = (filter: DateFilter) => {
    setSearchParams(dateFilterToSearchParams(filter));
  };

  return { dateFilter, setDateFilterFromUrl };
}
